import {Box, Flex, ListItem, OrderedList} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import BackgroundComponent from "../components/backgorund/BackgroundComponent";
import React from "react";

const PrivacyPolicy = () => {
    const [t, i18n] = useTranslation('common');
    return <Box paddingRight="20px"
                paddingLeft="20px"
                paddingTop="10px"
                className="App-body">
        <Flex direction="column" className="privacy-page">
        <span className="body-content-small-gray">
          {t("Updated")} 08.10.2021.
        </span>
            <Box marginBottom="40px" marginTop="10px" textAlign="left">
                <span className="body-description">{t("Indie Privacy Policy")}</span>
            </Box>
            <Box className="body-content-small-gray">
                <span>{t("Privacy Policy header")}</span>
                <OrderedList>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Who we are")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}> {t("Who we are 1")}</ListItem>
                            <ListItem padding={2}> {t("Who we are 2")}</ListItem>
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <Box>{t("Collection of information")}</Box>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}> {t("Collection of information 1")}
                                <OrderedList listStyleType="lower-roman">
                                    <ListItem padding={2}> <span>{t("Collection of information 1 1")}</span>
                                        <OrderedList>
                                            <ListItem padding={2}> <span>{t("Collection of information 1 1 1")}</span>
                                                <OrderedList listStyleType="lower-alpha">
                                                    <ListItem padding={2}>
                                                        <span>{t("Name;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Username;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Mobile number;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Email address;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Gender identity;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Date of birth;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Nationality;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Work preferences;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Photographs;")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("Location; and")}</span>
                                                    </ListItem>
                                                    <ListItem padding={2}>
                                                        <span>{t("login info")}</span>
                                                    </ListItem>
                                                </OrderedList>
                                            </ListItem>
                                            <ListItem padding={2}> {t("Collection of information 1 1 2")}</ListItem>
                                            <ListItem padding={2}> {t("Collection of information 1 1 3")}
                                                <OrderedList listStyleType="lower-alpha">
                                                    {Array(11).fill(null).map((value, index) => (
                                                        <ListItem padding={2}>
                                                            <span>{t("Collection of information 1 1 3 " + (index + 1))}</span>
                                                        </ListItem>
                                                    ))}
                                                </OrderedList>
                                            </ListItem>

                                        </OrderedList>
                                    </ListItem>
                                    <ListItem padding={2}> <span>{t("Collection of information 1 2")}</span>
                                        <OrderedList>
                                            <ListItem padding={2}> {t("Collection of information 1 2 1")}</ListItem>
                                            <ListItem padding={2}> {t("Collection of information 1 2 2")}</ListItem>
                                        </OrderedList>
                                    </ListItem>
                                    {Array(8).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Collection of information 1 " + (index + 3))}</span>
                                            <OrderedList>
                                                <ListItem
                                                    padding={2}> {t("Collection of information 1 " + (index + 3) + " 1")}</ListItem>
                                            </OrderedList>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Use of Your Information")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}> {t("Use of Your Information 1")}
                                <OrderedList listStyleType="lower-roman">
                                    <ListItem padding={2}> <span>{t("Use of Your Information 1 1")}</span>
                                        <OrderedList>
                                            {Array(29).fill(null).map((value, index) => (
                                                <ListItem padding={2}>
                                                    <span>{t("Use of Your Information 1 1 " + (index + 1))}</span>
                                                </ListItem>
                                            ))}
                                            <ListItem padding={2}>
                                                <span>{t("Use of Your Information 1 1 30")}</span>
                                            </ListItem>
                                            <OrderedList listStyleType="lower-alpha">
                                                {Array(3).fill(null).map((value, index) => (
                                                    <ListItem padding={2}>
                                                        <span>{t("Use of Your Information 1 1 30 " + (index + 1))}</span>
                                                    </ListItem>
                                                ))}
                                            </OrderedList>
                                        </OrderedList>
                                    </ListItem>
                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}> {t("Use of Your Information 2")}
                                <OrderedList listStyleType="lower-roman">
                                    {Array(2).fill(null).map((value, index) => (
                                        <ListItem padding={2}>
                                            <span>{t("Use of Your Information 2 " + (index + 1))}</span>
                                        </ListItem>
                                    ))}

                                </OrderedList>
                            </ListItem>
                            {Array(2).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Use of Your Information " + (index + 3))}</span>
                                </ListItem>
                            ))}
                            <ListItem padding={2}> {t("Use of Your Information 5")}
                                <OrderedList listStyleType="lower-roman">
                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 5 1")}</span>
                                        <OrderedList>
                                            <ListItem padding={2}>
                                                <span>{t("Use of Your Information 5 1 1")}</span>
                                                <OrderedList listStyleType="lower-alpha">
                                                    {Array(5).fill(null).map((value, index) => (
                                                        <ListItem padding={2}>
                                                            <span>{t("Use of Your Information 5 1 1 " + (index + 1))}</span>
                                                        </ListItem>
                                                    ))}
                                                </OrderedList>
                                            </ListItem>
                                        </OrderedList>
                                    </ListItem>
                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 5 2")}</span>

                                    </ListItem>

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}> {t("Use of Your Information 6")}
                                <OrderedList listStyleType="lower-roman">
                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 6 1")}</span>
                                        <OrderedList>
                                            {Array(5).fill(null).map((value, index) => (
                                                <ListItem padding={2}>
                                                    <span>{t("Use of Your Information 6 1 " + (index + 1))}</span>
                                                </ListItem>
                                            ))}
                                        </OrderedList>
                                    </ListItem>
                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 6 2")}</span>
                                        <OrderedList>
                                            {Array(4).fill(null).map((value, index) => (
                                                <ListItem padding={2}>
                                                    <span>{t("Use of Your Information 6 2 " + (index + 1))}</span>
                                                </ListItem>
                                            ))}
                                        </OrderedList>
                                    </ListItem>
                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 6 3")}</span>
                                    </ListItem>

                                </OrderedList>
                            </ListItem>
                            <ListItem padding={2}> {t("Use of Your Information 7")}
                                <OrderedList listStyleType="lower-roman">

                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 7 1")}</span>
                                    </ListItem>
                                    <ListItem padding={2}>
                                        <span>{t("Use of Your Information 7 2")}</span>
                                    </ListItem>

                                </OrderedList>
                            </ListItem>

                        </OrderedList>
                    </ListItem>

                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("What Others May See About You")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(5).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("What Others May See About You " + (index + 1))}</span>
                                </ListItem>
                            ))}


                        </OrderedList>
                    </ListItem>

                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Our Policy Towards Age")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(2).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Our Policy Towards Age " + (index + 1))}</span>
                                </ListItem>
                            ))}


                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Security")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                <span>{t("Security 1")}</span>
                            </ListItem> <ListItem padding={2}>
                            <span>{t("Security 2")}
                                <OrderedList listStyleType="lower-roman">
                                 
                                         {Array(3).fill(null).map((value, index) => (
                                             <ListItem padding={2}>
                                                 <span>{t("Security 2 " + (index + 1))}</span>
                                             </ListItem>
                                         ))}

                              
                                </OrderedList>
                            </span>
                        </ListItem> <ListItem padding={2}>
                            <span>{t("Security 3")}</span>
                        </ListItem>


                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Linking Other Accounts to Indie")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">

                            {Array(2).fill(null).map((value, mindex) => (
                                <ListItem padding={2}>
                                    <span>{t("Linking Other Accounts to Indie " + (mindex + 1))}</span>
                                    <OrderedList listStyleType="lower-roman">
                                       
                                            {Array(3).fill(null).map((value, index) => (
                                                <ListItem padding={2}>
                                                    <span>{t("Linking Other Accounts to Indie " + (mindex + 1) + " " + (index + 1))}</span>
                                                </ListItem>
                                            ))}

                                    </OrderedList>
                                </ListItem>
                            ))}

                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Your California Privacy Rights")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                            <span>{t("Your California Privacy Rights 1")}
                                <OrderedList listStyleType="lower-roman">
                          
                                         {Array(2).fill(null).map((value, index) => (
                                             <ListItem padding={2}>
                                                 <span>{t("Your California Privacy Rights 1 " + (index + 1))}</span>
                                             </ListItem>
                                         ))}
                                </OrderedList>
                                
                            </span>
                            </ListItem>
                         
                                {Array(3).fill(null).map((value, index) => (
                                    <ListItem padding={3}>
                                        <span>{t("Your California Privacy Rights " + (index + 2))}</span>
                                    </ListItem>
                                ))}

                           

                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Your Rights")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                            <span>{t("Your Rights 1")}
                                <OrderedList listStyleType="lower-roman">
                           
                                         {Array(8).fill(null).map((value, index) => (
                                             <ListItem padding={2}>
                                                 <span>{t("Your Rights 1 " + (index + 1))}</span>
                                             </ListItem>
                                         ))}

                      
                                </OrderedList>
                            </span>
                            </ListItem>
                            <ListItem padding={2}>
                                <span>{t("Your Rights 2")}</span>
                            </ListItem>


                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Data Locations")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                <span>{t("Data Locations 1")}</span>
                            </ListItem>


                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}>
                        <span>{t("Data Retention and Deletion")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            {Array(2).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Data Retention and Deletion " + (index + 1))}</span>
                                </ListItem>
                            ))}
                            <ListItem padding={2}>
                            <span>{t("Data Retention and Deletion 3")}
                                <OrderedList listStyleType="lower-roman">
                                
                                         {Array(4).fill(null).map((value, index) => (
                                             <ListItem padding={2}>
                                                 <span>{t("Data Retention and Deletion 3 " + (index + 1))}</span>
                                             </ListItem>
                                         ))}
                                </OrderedList>
                            </span>
                            </ListItem>
                            {Array(3).fill(null).map((value, index) => (
                                <ListItem padding={2}>
                                    <span>{t("Data Retention and Deletion " + (index + 4))}</span>
                                </ListItem>
                            ))}

                        </OrderedList>
                    </ListItem>
                    <ListItem className="sub-header-privacy" padding={2}> <span>{t("Changes to this Policy")}</span>
                        <OrderedList className="body-privacy" listStyleType="lower-alpha">
                            <ListItem padding={2}>
                                <span>{t("Changes to this Policy 1")}</span>
                            </ListItem>
                        </OrderedList>
                    </ListItem>
                </OrderedList>
            </Box>
        </Flex>
        <BackgroundComponent/>
    </Box>

}
export default PrivacyPolicy